import styled from "@emotion/styled";
export const StyledCarouselAssetComponent = styled.div`
  margin: auto;
  &.default-style {
    .carousel {
      .slick-slider {
        &.focus {
          .slick-list {
            .slick-track {
              .slick-slide {
                .carousel-item {
                  opacity: 1;
                  padding: 0 var(--image-padding);

                  .picture-component {
                    height: 100%;
                    width: 100%;
                  }
                }

                &.slick-center.slick-active {
                  .carousel-item {
                    transform: scale(1);
                  }
                }
              }
            }
          }
        }

        .slick-list {
          .slick-track {
            display: flex;
            padding-top: 0;

            .slick-slide {
              opacity: 1;
              transition: opacity 0.5s ease-in-out;

              height: auto;
              > div:first-child {
                height: 100%;
              }
            }

            .carousel-item {
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }

    .image-slide {
      height: var(--image-height, 100%);
    }
  }

  .image-slide {
    cursor: grab;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;
